var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5"},[_c('vs-tabs',{attrs:{"alignment":"fixed"}},[_c('vs-tab',{attrs:{"label":"Revision estudiantes"}},[_c('RevisionEstudiantes',{staticClass:"mt-3"})],1),_c('vs-tab',{attrs:{"label":"Actualización de estudiantes"}},[_c('ActualizacionEstudiantes')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }